import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    claimItemTitle: {
        id: 'claim.views.claim-detail.Claim Item',
        defaultMessage: 'Claim Item'
    },
    adjusterEmail: {
        id: 'claim.views.claim-detail.Email Address',
        defaultMessage: 'Email Address'
    },
    lossParty: {
        id: 'claim.views.claim-detail.Loss Party',
        defaultMessage: 'Loss Party'
    },
    claimant: {
        id: 'claim.views.claim-detail.Claimant',
        defaultMessage: 'Claimant'
    },
    type: {
        id: 'claim.views.claim-detail.Type',
        defaultMessage: 'Type'
    },
    risk: {
        id: 'claim.views.claim-detail.Risk',
        defaultMessage: 'Risk'
    },
    back: {
        id: 'portal.index.Back',
        defaultMessage: 'Back'
    }
});
